// extracted by mini-css-extract-plugin
module.exports = {"button":"StoreDownloadButton_button__lwu4h","image":"StoreDownloadButton_image__u1nWg"};